const translation = {
  nav: {
    home: 'Home',
    about: 'About',
    members: 'Members',
    blog: 'Blog',
    consultation: 'Consultation',
    contact: 'Contact',
  },

  // Hero Section
  'hero.title': 'Creating the Future Together with the Community',
  'hero.subtitle': 'Yoshino Village Project',
  'hero.description': 'A collaborative community project aimed at sustainable regional development. Creating the future of Yoshino together through community exchange, environmental conservation, and human resource development.',
  'hero.cta.learn': 'Learn More',
  'hero.cta.join': 'Join Us',

  // About Section
  'about.title': 'About the Project',
  'about.subtitle': 'Yoshino Village Project',
  'about.description': 'Yoshino Village Project is a collaborative community project aimed at sustainable regional development. Creating the future of Yoshino together through community exchange, environmental conservation, and human resource development.',
  'about.vision.title': 'Vision',
  'about.vision.description': 'Creating a sustainable community where people and nature are in harmony, passing on Yoshino\'s rich culture and nature to the next generation.',
  'about.mission.title': 'Mission',
  'about.mission.description': 'Revitalizing the region and creating new value through collaboration between local residents and external supporters.',
  'about.values.title': 'Values',
  'about.values.description': 'Respecting diversity, valuing dialogue, and acting together. Pursuing sustainable growth through collaborative community creation.',

  // Members Section
  'members.preview.title': 'Project Members',
  'members.preview.subtitle': 'Team Introduction',
  'members.preview.description': 'Members with diverse backgrounds and expertise are working together to create the future of Yoshino.',
  'members.preview.cta': 'View All Members',
  'members.page.title': 'Project Members',
  'members.page.subtitle': 'Team Introduction',
  'members.page.description': 'Members with diverse backgrounds and expertise are working together to create the future of Yoshino.',

  // Blog Section
  'blog.preview.title': 'Latest Activities',
  'blog.preview.subtitle': 'Blog',
  'blog.preview.description': 'Check out our latest activity reports and event information.',
  'blog.preview.cta': 'View All Articles',
  'blog.page.title': 'Blog',
  'blog.page.subtitle': 'Activity Reports & Event Information',
  'blog.page.description': 'Check out our latest activity reports and event information.',
  'blog.readMore': 'Read More',
  'blog.backToList': 'Back to Blog List',

  // News Section
  'news.title': 'Latest News',
  'news.subtitle': 'News & Announcements',
  'news.viewAll': 'View All News',

  // Activities Section
  'activities.title': '3 Pillars of Our Activities',
  'activities.subtitle': 'Our Activities',
  'activities.community.title': 'Community Exchange',
  'activities.community.description': 'Strengthening community bonds through events and workshops that connect local residents with external supporters.',
  'activities.environment.title': 'Environmental Conservation',
  'activities.environment.description': 'Passing on Yoshino\'s rich nature to the next generation through forest conservation and sustainable agriculture.',
  'activities.education.title': 'Human Resource Development',
  'activities.education.description': 'Nurturing the next generation of leaders through educational programs and internships.',

  // Voices Section
  'voices.title': 'Participant Voices',
  'voices.subtitle': 'Testimonials',

  // Join Section
  'join.title': 'Join Our Community',
  'join.subtitle': 'Become a Member',
  'join.description': 'We are looking for people who want to create the future of Yoshino together. Anyone can participate regardless of age, experience, or place of residence.',
  'join.volunteer.title': 'Volunteer',
  'join.volunteer.description': 'Participate in events and activities. You can participate as little as once a month.',
  'join.supporter.title': 'Supporter',
  'join.supporter.description': 'Support the project through donations or sponsorships.',
  'join.partner.title': 'Partner',
  'join.partner.description': 'Form partnerships as a company or organization.',
  'join.cta': 'Contact Us',

  // Social Section
  'social.title': 'Social Media',
  'social.subtitle': 'Follow Us',
  'social.instagram.title': 'Instagram',
  'social.instagram.description': 'Check our daily activities and beautiful landscapes of Yoshino',
  'social.youtube.title': 'YouTube',
  'social.youtube.description': 'Watch project introduction videos and event reports',

  // Contact Page
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Get in Touch',
  'contact.description': 'Please feel free to contact us with any questions about the project, inquiries about participation, or proposals for collaboration.',
  'contact.form.title': 'Contact Form',
  'contact.form.name': 'Name',
  'contact.form.name.placeholder': 'John Doe',
  'contact.form.email': 'Email Address',
  'contact.form.email.placeholder': 'example@email.com',
  'contact.form.subject': 'Subject',
  'contact.form.subject.placeholder': 'Enter subject',
  'contact.form.message': 'Message',
  'contact.form.message.placeholder': 'Enter your message',
  'contact.form.submit': 'Send',
  'contact.form.submitting': 'Sending...',
  'contact.form.success': 'Your message has been sent. Our team will get back to you shortly.',
  'contact.form.error': 'Failed to send. Please try again.',
  'contact.info.title': 'Contact Information',
  'contact.info.address': 'Address',
  'contact.info.email': 'Email',
  'contact.info.phone': 'Phone',
  'contact.access.title': 'Access',

  // Footer
  'footer.description': 'A collaborative community project aimed at sustainable regional development',
  'footer.quickLinks': 'Quick Links',
  'footer.followUs': 'Follow Us',
  'footer.newsletter.title': 'Newsletter',
  'footer.newsletter.description': 'Get the latest updates',
  'footer.newsletter.placeholder': 'Enter your email',
  'footer.newsletter.subscribe': 'Subscribe',
  'footer.newsletter.success': 'Successfully subscribed!',
  'footer.newsletter.error': 'Failed to subscribe. Please try again.',
  'footer.copyright': '© 2024 Yoshino Village Project. All rights reserved.',

  // 404 Page
  'notFound.title': 'Page Not Found',
  'notFound.description': 'The page you are looking for does not exist.',
  'notFound.backHome': 'Back to Home',

  // Common
  'common.readMore': 'Read More',
  'common.learnMore': 'Learn More',
  'common.viewAll': 'View All',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  
  // About Page
  aboutPage: {
    hero: {
      title: 'About Us',
      subtitle: 'Yoshino Village Network',
      description: 'Where challengers meet the community',
    },
    whatIsYVN: {
      title: 'What is Yoshino Village Network',
      description1: 'Yoshino Village Network is a platform connecting people who want to engage with the community in Yoshino Town, Nara Prefecture.',
      description2: 'We are not a site showcasing finished projects. We are a space for sharing ongoing challenges, trials, and possibilities.',
      description3: 'This is a place to create "opportunities for participation."',
    },
    whyStarted: {
      title: 'Why We Started',
      challenges: {
        title: 'Challenges Yoshino Faces',
        description1: 'Yoshino Town is a region with beautiful nature and rich history. However, like many rural areas, it faces challenges such as population decline, aging, and youth outflow.',
        description2: 'Particularly serious is the lack of jobs for young people to settle. Even those who want to stay face difficulties in building a foundation for living.',
      },
      answer: {
        title: 'Our Answer',
        description1: 'For this challenge, we believed that "just attracting people from outside is not enough."',
        description2: 'What\'s needed is to create "jobs," generate "value," and restore "pride" in the community.',
        description3: 'To achieve this, we need a space where diverse people—locals, migrants, and visitors—can engage as equals and challenge together.',
      },
    },
    activities: {
      title: 'Our Activities',
      gateway: {
        title: 'Creating Gateways',
        description: 'From "interested in Yoshino" to "engaged with Yoshino." We provide various "gateways" for people to take concrete action. Consultation services, events, project participation—engagement varies by person.',
      },
      jobs: {
        title: 'Creating Jobs',
        description: 'To create jobs for young people to settle, we work on launching new businesses utilizing local resources and revitalizing existing industries. We challenge in various fields like forestry, construction, and food.',
      },
      community: {
        title: 'Community Building',
        description: 'We create spaces where locals, migrants, and visitors can interact as equals. Through regular meetings and events, we nurture a community of mutual learning and support.',
      },
      information: {
        title: 'Information Sharing',
        description: 'We share challenges and trials happening in Yoshino in real-time. By sharing not just successes but also failures and issues, we value transparency and trust.',
      },
    },
    values: {
      title: 'Our Values',
      experimental: {
        title: 'Experimental',
        description: 'We start without aiming for perfection. We share failures and learn from them.',
      },
      workInProgress: {
        title: 'Work in Progress',
        description: 'We value the ongoing process, not the finished product. People who come now can participate in the design.',
      },
      equal: {
        title: 'Equal',
        description: 'Locals, migrants, and visitors are all equal. We challenge together regardless of position.',
      },
    },
    members: {
      title: 'People Gathering in Yoshino',
      subtitle: 'Meet the people with diverse backgrounds engaging with Yoshino in their own ways',
      readStory: 'Read Story',
    },
    vision: {
      title: 'What We Aim For',
      settlement: {
        title: 'A Community Where Young People Can Settle',
        description: 'We aim for a community with attractive jobs where people can build a foundation for living. We create new industries utilizing local resources and an environment where young people want to live.',
      },
      pride: {
        title: 'A Society Where People Take Pride in Their Community',
        description: 'We aim for a society where local people have confidence in their culture, skills, and nature, and can pass them on to the next generation. We value pride that comes from within, not relying on external validation.',
      },
      diverse: {
        title: 'A Space Where Diverse People Can Engage',
        description: 'We aim for a space where everyone—locals, migrants, visitors—can engage as equals regardless of position or background. From "consumer" to "producer," from "spectator" to "participant." We increase companions who challenge together.',
      },
    },
    cta: {
      title: 'Want to Engage with Yoshino?',
      description: 'Questions like "I don\'t know where to start" or "I want to know what I can do" are very welcome.',
      button: 'Contact Yoshino Consultation',
      responseTime: 'Response time: 2-3 business days',
    },
  },
  
  thisWeek: {
    title: 'This Week in Yoshino Village',
    subtitle: 'What\'s happening in real-time and what you can participate in',
    schedule: 'This Week\'s Schedule',
    updates: 'Recent Updates',
    moreOnInstagram: 'More detailed activity updates on Instagram',
  },
  
  gateway: {
    title: 'Yoshino Consultation Hub',
    subtitle: 'From "just curious" to "seriously considering relocation" - any consultation is welcome.',
    description: 'Members who are actually active in Yoshino will share real information with you.',
    chooseMethod: 'Choose your consultation method',
    replyTime: 'We usually reply within 24 hours. Feel free to reach out!',
    contactForm: 'Consult via Form',
    chatConsultation: 'Chat Consultation',
    comingSoon: 'Coming Soon',
    tip: 'We recommend starting with our casual online meetup (every Wednesday 7:00 PM)',
  },
  
  instagram: {
    title: 'Real Daily Life',
    subtitle: 'Authentic activity updates from #YoshinoVillageProject posts',
    viewAll: 'View All Posts on Instagram',
  },
  
  youtube: {
    title: 'People Speak About Real Yoshino',
    subtitle: 'Migrants, locals, and challengers. Yoshino today from different perspectives',
    viewChannel: 'Visit YouTube Channel',
  },
  
  results: {
    title: 'Results by Numbers',
    subtitle: 'Small but steady progress',
    projectsTitle: 'Currently Active Projects',
    projectsSubtitle: 'You might be able to participate too',
    progress: 'Progress',
    viewDetails: 'View Details',
  },
  
  honestVoices: {
    title: 'Real Voices (Honest Edition)',
    subtitle: 'Both the good and the challenging aspects. We tell it like it is',
    notSuitable: 'Honestly, this might not be suitable for these types of people',
    notSuitableDesc: 'To prevent mismatches, we\'ll be upfront about this',
    tip: 'But if you have the desire to "give it a try", please reach out to us first',
  },

  // Additional sections that were in components
  liveLog: {
    title: 'Live Activity Log',
    subtitle: 'Real-time updates from the field',
    viewAll: 'View Full Activity Log',
  },

  manifesto: {
    title: 'Our Vision in Motion',
    subtitle: 'Watch our community manifesto',
    watchVideo: 'Watch Video',
  },

  peopleSpotlight: {
    title: 'People in Focus',
    subtitle: 'Stories from community members',
    readStory: 'Read Their Story',
  },

  happeningNow: {
    title: 'Happening Right Now',
    subtitle: 'Current activities and opportunities',
    joinNow: 'Join Now',
  },

  socialProof: {
    title: 'Community Impact',
    subtitle: 'Real results from real people',
    members: 'Active Members',
    projects: 'Ongoing Projects',
    events: 'Events This Month',
  },

  threeSteps: {
    title: '3 Simple Steps to Get Started',
    subtitle: 'Your journey begins here',
    step1: 'Connect',
    step1Desc: 'Reach out and join our community',
    step2: 'Participate',
    step2Desc: 'Join activities that match your interests',
    step3: 'Contribute',
    step3Desc: 'Make your unique impact on Yoshino',
  },

  threeWays: {
    title: '3 Ways to Get Involved',
    subtitle: 'Choose what works for you',
    visit: 'Visit',
    visitDesc: 'Come experience Yoshino firsthand',
    support: 'Support',
    supportDesc: 'Help from wherever you are',
    move: 'Move',
    moveDesc: 'Make Yoshino your new home',
  },

  threeEntrances: {
    title: '3 Entry Points',
    subtitle: 'Multiple ways to start your journey',
    online: 'Online',
    onlineDesc: 'Join virtual events and discussions',
    visit: 'Visit',
    visitDesc: 'Come for events and workshops',
    stay: 'Stay',
    stayDesc: 'Experience extended community life',
  },

  finalCTA: {
    title: 'Ready to Begin?',
    subtitle: 'Your Yoshino journey starts with a simple conversation',
    description: 'Whether you\'re curious, committed, or somewhere in between, we\'d love to hear from you.',
    startConversation: 'Start a Conversation',
    visitUs: 'Visit Us',
  },

  peopleCommunity: {
    title: 'The People Who Make Yoshino',
    subtitle: 'Meet the faces behind the community',
    viewProfile: 'View Profile',
  },

  ongoingChallenges: {
    title: 'Current Challenges & Opportunities',
    subtitle: 'Where we need help and how you can contribute',
    getInvolved: 'Get Involved',
  },

  notForEveryone: {
    title: 'This Isn\'t For Everyone',
    subtitle: 'And that\'s perfectly okay',
    description: 'We believe in being honest about what community life in Yoshino really involves.',
    learnMore: 'Learn What to Expect',
  },

  honestScope: {
    title: 'What We\'re Really About',
    subtitle: 'Our scope, honestly explained',
    description: 'We focus on sustainable community building, not quick fixes or unrealistic promises.',
    exploreApproach: 'Explore Our Approach',
  },

  privacy: {
    title: 'Privacy Policy',
    subtitle: 'How we protect your information',
    lastUpdated: 'Last updated',
    backToHome: 'Back to Home',
  },

  consultation: {
    title: 'Book a Consultation',
    subtitle: 'Let\'s talk about your Yoshino journey',
    description: 'Schedule a free consultation with our community coordinators to explore how you can get involved.',
    bookConsultation: 'Book Your Session',
  },
} as const;

export default translation;